<template>
    <div>
        <el-breadcrumb separator="/" style="margin-bottom: 20px">
            <el-breadcrumb-item :to="{ path: '/main/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>统计报表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row style="margin:20px 0">
            <el-col :span="6" style="padding:10px">
                <div class="el-card is-hover-shadow">
                    <div class="el-card__body" style="padding: 0px;">
                        <div class="grid-content grid-con-1">
                            <i class="el-icon-s-custom grid-con-icon"></i>
                            <div class="grid-cont-right">
                                <div class="grid-num">{{counts.total}}</div>
                                <div>累计预约</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6" style="padding:10px">
                <div class="el-card is-hover-shadow">
                    <div class="el-card__body" style="padding: 0px;">
                        <div class="grid-content grid-con-2">
                            <i class="el-icon-s-shop grid-con-icon"></i>
                            <div class="grid-cont-right">
                                <div class="grid-num">{{counts.today}}</div>
                                <div>今日预约</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6" style="padding:10px">
                <div class="el-card is-hover-shadow">
                    <div class="el-card__body" style="padding: 0px;">
                        <div class="grid-content grid-con-3">
                            <i class="el-icon-s-flag grid-con-icon"></i>
                            <div class="grid-cont-right">
                                <div class="grid-num">{{counts.doctors}}</div>
                                <div>出诊医生</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6" style="padding:10px">
                <div class="el-card is-hover-shadow">
                    <div class="el-card__body" style="padding: 0px;">
                        <div class="grid-content grid-con-4">
                            <i class="el-icon-s-opportunity grid-con-icon"></i>
                            <div class="grid-cont-right">
                                <div class="grid-num">{{counts.departments}}</div>
                                <div>开设科室</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin:30px 0">
            <el-col :span="16">
                <line-chart/>
            </el-col>
            <el-col :span="8">
                <pie-chart/>
            </el-col>
        </el-row>
    </div>
</template>

<style scoped>
    .grid-content {
        display: flex;
        align-items: center;
        height: 130px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 130px;
        text-align: center;
        line-height: 130px;
        color: #fff;
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(195, 191, 226);
    }

    .grid-con-3 .grid-num {
        color: rgb(195, 191, 226);
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(128, 176, 210);
    }

    .grid-con-1 .grid-num {
        color: rgb(128, 176, 210);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(141, 210, 198);
    }

    .grid-con-2 .grid-num {
        color: rgb(141, 210, 198);
    }

    .grid-con-4 .grid-con-icon {
        background: rgb(144, 147, 153);
    }

    .grid-con-4 .grid-num {
        color: rgb(144, 147, 153);
    }
</style>
<script>
    export default {
        data() {
            return {
                counts: {
                    total: 0,
                    today: 0,
                    doctors: 0,
                    departments: 0,
                }
            }
        },
        methods: {
            async getData() {
                const resp = await this.$http.get(`/mingde/statistics/counts`)
                this.counts = resp.data.data
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>
